// extracted by mini-css-extract-plugin
module.exports = {"QuizItem":"QuizItem_QuizItem__2ZU2Q","Title":"QuizItem_Title__1kQIG"};